import { Box, Flex } from '@chakra-ui/react';
import { ReactNode } from 'react';
import Navbar from './Navbar';
import UtilityPanel from './UtilityPanel';

interface Props {
  children: ReactNode;
}

function Layout({ children }: Props) {
  return (
    <Flex height="100%">
      <Navbar />
      <Box flex={1} py="20px">
        {children}
      </Box>
      <UtilityPanel />
    </Flex>
  );
}

export default Layout;
